import { DocumentType } from '@iota/iota-management-portal-v4-client';

// All steps which are visible in the dialog, the enum here defines the order!
export enum SMART_DOCUMENT_UPLOAD_STEP {
    UPLOAD_FILE_AND_CATEGORIZE,
    UPLOAD_NEXT_FILE,
    RESULT
}
export const SmartDocumentUploadStepLabels: { [K in SMART_DOCUMENT_UPLOAD_STEP]: string } = {
    [SMART_DOCUMENT_UPLOAD_STEP.UPLOAD_FILE_AND_CATEGORIZE]: $localize`Upload file and categorize`,
    [SMART_DOCUMENT_UPLOAD_STEP.UPLOAD_NEXT_FILE]: $localize`Upload next file`,
    [SMART_DOCUMENT_UPLOAD_STEP.RESULT]: $localize`Completion`
};

export interface SmartDocumentUploadFileData {
    file: File;
    businessPartnerNumber: string;
    documentType: DocumentType;
    date: string;
}
